import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription, firstValueFrom } from 'rxjs';

import { UserService } from '../../services/user/user.service';
import { StudioSidebarService } from '../../services/studio-sidebar/studio-sidebar.service';
import { SessionsService } from '../../services/sessions/sessions.service';
import { DescriptFile, Take } from '@sc/types';
import { RecordingsService } from '../../services/recordings/recordings.service';
import { Recording } from '@sc/types';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { IdTokenService } from '../../services/id-token/id-token.service';
import { DescriptService } from '../../services/descript/descript.service';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { GeneralToastComponent } from '../../toasts/general-toast/general-toast.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'sc-recordings-takes',
  templateUrl: './recordings-takes.component.html',
  styleUrls: ['./recordings-takes.component.scss'],
})
export class RecordingsTakesComponent implements OnInit, OnDestroy {
  @Output() closeSidebar = new EventEmitter<boolean>();
  @Output() selectTakeID = new EventEmitter<string>();
  activeUser$ = this.userService.activeUser$;
  studioSession$ = this.sessionsService.studioSession$;
  previewRecordings$ = this.sessionsService.getAllPreviewRecordingsInSession();
  takes: Array<Take>;
  subs: Array<Subscription> = [];

  constructor(
    private userService: UserService,
    private studioSidebarService: StudioSidebarService,
    private sessionsService: SessionsService,
    private recordingsService: RecordingsService,
    private analyticsService: AnalyticsService,
    private idTokenService: IdTokenService,
    private descriptService: DescriptService,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {
    this.setupTakes();
  }

  /**
   * Selects one active take
   *
   * @param take
   */
  async select(take: Take) {
    this.selectTakeID.emit(take.takeID);
    await this.analyticsService.track('selected take', { take });
  }

  /**
   * Sends recordings from selected take to Edit in Descript
   *
   * @param selectedTake
   */
  async editInDescript(selectedTake: Take) {
    const recordingsFromTake = await firstValueFrom(
      this.recordingsService.getAllRecordingsFromTake(selectedTake.sessionID, selectedTake.takeNumber)
    );
    this.descriptService.editInDescript(recordingsFromTake);
  }

  /*
   * Prevents flickering/flashing in the list of takes
   *
   * @param index - number
   * @param take - Take
   * @returns - number
   */
  trackTakesBy(index: number, take: Take) {
    return take.takeNumber;
  }

  /**
   * Prevents flickering/flashing in the list of preview recordings
   *
   * @param index - number
   * @param recording - Recording
   * @returns - number
   */
  trackPreviewRecordingsBy(index: number, recording: Recording) {
    return recording.recordingID;
  }

  /**
   * Sets up the sorted takes
   */
  setupTakes() {
    const sub = this.recordingsService.getTakesFromSession(this.studioSession$.value.sessionID).subscribe((takes) => {
      if (!takes) return;
      this.takes = takes;
    });

    this.subs.push(sub);
  }

  ngOnDestroy(): void {
    this.subs.map((sub) => sub.unsubscribe());
  }
}
